import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { RefreshCcw, Activity } from "lucide-react";

const ContrarianTradersPage = () => {
  return (
    <div className="min-h-screen bg-slate-950 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-gradient-to-br from-red-500 to-orange-600 rounded-lg flex items-center justify-center">
            <RefreshCcw className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-white">Contrarian Traders</h1>
            <p className="text-slate-400 text-sm">Against-the-crowd opportunities</p>
          </div>
        </div>
        
        <Card className="bg-slate-900 border-slate-800">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Activity className="w-5 h-5 text-red-400" />
              Coming Soon
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-slate-400">
              This page will identify contrarian trading opportunities based on 
              extreme sentiment readings, oversold/overbought conditions, and crowd positioning.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ContrarianTradersPage;
